import { styled, TextField } from "@mui/material";
import { palette } from "../../themes/theme";

// const PrimaryTextField = (props) => {
//   return <CustomTextField {...props} />;
// };

const CustomTextField = styled(TextField)(({ showSpinBtn = true }) => ({
  marginBottom: "0px",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "white",
    color: "black",
    borderRadius: "4px",
    "& fieldset": {
      borderColor: "black", // default border
    },
    "&:hover fieldset": {
      borderColor: "black", // on hover
    },
    "&.Mui-focused fieldset": {
      borderColor: palette.primary.main, // on focus
    },
  },
  "& .MuiInputLabel-root": {
    color: "black", // label color
  },
  "& .MuiFormHelperText-root": {
    color: "red",
  },
  ...(!showSpinBtn
    ? {
        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
          {
            display: "none",
          },
        "& input[type=number]": {
          MozAppearance: "textfield",
        },
      }
    : {}),
}));

export default CustomTextField;
